import React from 'react'
import styles from './EmptyRoutes.scss'
import { dashboardMessages } from '../../Dashboard/intlMessages'
import { Card } from 'common/styleguide/Card'
import { Icon } from 'common/Icon'
import { CTA } from 'common/styleguide/CTA'
import { Msg, featureNames } from 'lib/localization'
import { FormattedMessage as T } from 'react-intl'

export const EmptyRoutes = () => {
  return (
    <div className={styles.EmptyRoutes}>
      <h2 data-heading-alt><Msg m={featureNames.routes} /></h2>
      <Card className={styles.mainCard}>
        <Icon i='route-graphic' size={100} />
        <h1 data-heading-alt className={styles.buildYourRide}>
          <T id='EmptyRoutes.buildYourRide' defaultMessage='Build Your Ride' />
        </h1>
        <div className={styles.leadText}>
          <h2>
            <T id='EmptyRoutes.planOne' defaultMessage='Use the route planner to create completely custom routes and cuesheets. Just click on the map to plot your route, and the planner will take care of the cuesheet automatically.' />
          </h2>
        </div>
        <CTA margins={false} href='/routes/new'>
          <Msg m={dashboardMessages.planARoute} />
        </CTA>
      </Card>
    </div>
  )
}
